"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ResourceList_1 = __importDefault(require("../ResourceList"));
const City_1 = __importDefault(require("../models/City"));
const utils_1 = require("../utils");
class Cities {
    constructor(client) {
        this.client = client;
    }
    fromId(cityId) {
        return new City_1.default(this.client, { city_id: cityId });
    }
    async list(params = {}) {
        const url = encodeURI('/cities');
        const result = await this.client.get(url, {
            search: params.query,
            cursor: params.cursor,
            order: utils_1.toSnakeCase(params.order),
        });
        const { data: { data: cities, cursor }, } = result;
        const data = cities.map((city) => new City_1.default(this.client, city));
        return new ResourceList_1.default(data, this.list.bind(this), cursor);
    }
    async get(cityid) {
        const url = `/cities/${cityid}`;
        const { data: { data: city }, } = await this.client.get(url);
        return new City_1.default(this.client, city);
    }
}
exports.default = Cities;
//# sourceMappingURL=Cities.js.map